<template>
  <div
    class="base-image-input placeholderBG"
    :style="{ 'background-image': `url(${value})` }"
    @click="chooseImage"
  >
    <span class="placeholder">{{$vuetify.lang.t('$vuetify.action.change_image')}}</span>
    <input v-if="!limited" ref="fileInput" class="file-input" type="file" @change="onSelectFile" />
  </div>
</template>

<script>
export default {
  methods: {
    chooseImage() {
      if (!this.limited) {
        this.$refs.fileInput.click();
      }
    },
    onSelectFile() {
      const [file] = this.$refs.fileInput.files || [];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = event => this.$emit("input", event.target.result);
      reader.readAsDataURL(file);
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    limited: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.base-image-input {
  display: block;
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  color: #333;
  font-size: 18px;
  font-family: Helvetica;
}
.placeholderBG {
  background-color: #dadada;
  border: 1px solid #c1c1c1
}
.file-input {
  display: none;
}
</style>
